<template>
  <div class="mb-3" >
    <button type="button" class="button-pagination" @click="changePage(1)" :disabled="currentPage <= 1" v-show="quantityPages >= 5">
       <img src="@/assets/icons/chevron-double-left.svg"/>
    </button>

    <button type="button" class="button-pagination" @click="changePage(currentPage - 1)" :disabled="currentPage <= 1">
      <img src="@/assets/icons/chevron-left.svg"/>
    </button>

    <button 
        type="button" 
        v-for="(page, index) in displayedPages"
        :key="'page-' + index"
        class="button-pagination" 
        :class="{
          'button-pagination-selected' : page == currentPage,
          'button-ellipsis': page === '...' 
        }"
        :disabled="page === '...' || quantityPages == 1"
        @click="page !== '...' ? changePage(page) : null"
    >
      {{ page }}
    </button>

    <button type="button" class="button-pagination" @click="changePage(currentPage + 1)" :disabled="currentPage >= quantityPages">
      <img src="@/assets/icons/chevron-right.svg"/>
    </button>

    <button type="button" class="button-pagination" @click="changePage(quantityPages)" :disabled="currentPage >= quantityPages" v-show="quantityPages >= 5">
      <img src="@/assets/icons/chevron-double-right.svg"/>
    </button>
  </div>
</template>

<script>


export default {
  name: 'Pagination',
  props: {
    currentPage: { type: Number, required: true },
    quantityPages: { type: Number, required: true }
  },
  data() {
    return {
      
    }
  },
  computed: {
    displayedPages() {
      const total = this.quantityPages;
      const current = this.currentPage;
      const pages = [];

      if (total <= 7) {
        for (let i = 1; i <= total; i++) pages.push(i);
      } else {
        if (current <= 4) {
          for (let i = 1; i <= 5; i++) pages.push(i);
          pages.push('...');
          pages.push(total);
        } else if (current >= total - 3) {
          pages.push(1);
          pages.push('...');
          for (let i = total - 4; i <= total; i++) pages.push(i);
        } else {
          pages.push(1);
          pages.push('...');
          pages.push(current - 1);
          pages.push(current);
          pages.push(current + 1);
          pages.push('...');
          pages.push(total);
        }
      }
      return pages;
    }
  },
  methods: {
    changePage(page) {
      if (page >= 1 && page <= this.quantityPages) {
        this.$emit('change-page', page);
      }
    }
  }
}
</script>

<style scoped>

.button-pagination {
    border: 0.5px solid #DEE2E6;
    background: #FFF;
    color: #007A4A;
    text-align: center;
    font-family: "Trebuchet MS";
    font-size: 14px;
    padding: 4px 8px;
    min-width: 31px;
}

.button-pagination-selected {
    color: white;
    background-color: #007A4A;    
}

.button-pagination:disabled {
    border: 0.5px solid #DEE2E6;
    background: #DEE2E6;
    color: #6C757D;
}

.button-pagination.button-ellipsis {
    border: 0.5px solid #DEE2E6;
    background: #FFFFFF;
    color: #6C757D;
}


</style>